import { render, staticRenderFns } from "./UserSheet.vue?vue&type=template&id=12f9cf8a&v-if=sahabat&"
import script from "./UserSheet.vue?vue&type=script&lang=js&"
export * from "./UserSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports